




















    import {Vue, Component, Prop, Watch, Emit} from 'vue-property-decorator'
    import dataProxy from '@/services/data-proxy.service'
    import {formatDate} from "@/utils/formatters";
    import {DokumentInfo} from "@/services/BackendProxies";

@Component({})
export default class BrojeviDokumentaEditor extends Vue {
    @Prop() value!: string;
    @Prop({default: ''}) tipDokumenta!: string;
    searchVisible = false;
    dokumenta = [];
    columns = [];

    created() {
        this.columns = [
            {field: 'datum', title: this.$i18n.t('datum'), formatter: formatDate},
            {field: 'broj', title: '#'},
            {field: 'vozilo', title: this.$i18n.t('vozilo')},
            {field: 'dobavljac', title: this.$i18n.t('dobavljac')},
            {field: 'dokumentKreirao', title: this.$i18n.t('dokumentKreirao')},
        ];
    }

    loader = async (params, success, failure) => {
        const dokumenta = await dataProxy.vratiDokumentaPoBroju(params.data.term);
        success(dokumenta);
    };

    processResults(data: any[]) {
        return {
            results: data.map(x => ({id: x.id, text: x.broj}))
        }
    }

    @Emit('input') changed(value) {}

    async showSearch() {
        this.searchVisible = true;
        this.dokumenta = await dataProxy.pretraziDokumenteOdrzavanja(
            this.tipDokumenta, null, null, null, null, null, 0);
    }

    izaberiDokument(dokument: DokumentInfo) {
        this.changed(dokument.id);
        this.searchVisible = false;
    }

}
